import { Dashboard, DashboardLink } from "@/components/Dashboard/Dashboard";
import { EmptyState } from "@/components/EmptyState/EmptyState";
import { Box, Theme, useMediaQuery, useTheme } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface NotFoundProps {
  primaryLinks: DashboardLink[];
  footerLinks: DashboardLink[];
}

const NotFound: FC<NotFoundProps> = (props) => {
  const { t } = useTranslation("common");
  const theme = useTheme();

  // Using the same breakpoint as Dashboard,
  // since the text content refers to navigation buttons / navigation menu in the Dashboard
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dashboard primaryLinks={props.primaryLinks} footerLinks={props.footerLinks}>
      <Box
        component="div"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          minHeight: "370px",
          bgcolor: (theme: Theme) => theme.surface.low,
          borderRadius: "1em",
          padding: "1em",
          boxSizing: "border-box"
        }}
      >
        <EmptyState
          image={<img src="/images/not-found.svg" />}
          title={t("notFoundPage.title")}
          message={t("notFoundPage.message", {
            context: smDown ? "narrow" : "wide"
          })}
        />
      </Box>
    </Dashboard>
  );
};

export { NotFound };
